import React, { useState, useEffect } from 'react'
import { Link, Redirect } from "react-router-dom";
import { ArrowBackIcon, ChevronRight } from "~/Components/Icons/Icons";
import AdminValidationFileUploader from "./AdminValidationFileUploader";
import { adminHttp } from "~/Admin/services/http";
import Moment from "react-moment";
import { humanFileSize } from '~/helpers/utils';
import { connect } from "react-redux";

const AdminUploadValidation = ({ match, event }) => {

    const [uploaded, setUploaded] = useState(null);
    const [response, setResponse] = useState({});

    const endpoint = '/events/' + event.id + '/validations';

    const loadData = () => {
        adminHttp
            .get(endpoint)
            .then(res => {
                setResponse(res.data);
            });
    };

    useEffect(loadData, [event]);

    if (uploaded) {
        return <Redirect to={`${match.path}/${uploaded.id}`} />
    }

    return (
        <div className="validate-data">

            <div className="row">

                <div className="col-6">
                    <Link to="/guests/invitation" className="btn btn-secondary btn-sm mb-4">
                        <ArrowBackIcon classes="d-inline mr-2" />
                        Back
                    </Link>
                </div>
                <div className="col-6 text-right">
                    <a href={'/admin-api' + endpoint + '/template'} target="_blank" className="btn btn-primary btn-sm">
                        Download template</a>
                </div>

            </div>

            <h2 className="mb-4">Upload Guest Data</h2>

            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    <h3 className="mb-2">File Upload</h3>
                    <p className="mb-4">Upload your file containing your guest’s details to verify and validate them. If successful, they will be uploaded onto the system.</p>
                    <AdminValidationFileUploader onUploaded={row => setUploaded(row)} />
                </div>
            </div>

            {response.data && (
                <>
                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <h3 className="text-primary mb-4">Recent Validations</h3>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Size</th>
                                        <th scope="col">Rows</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Status</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {response.data?.map((validation) => (
                                        <tr key={validation.id}>
                                            <th scope="row">{validation.id}</th>
                                            <td>{validation.name}</td>
                                            <td>{humanFileSize(validation.size)}</td>
                                            <td>{validation.row_count}</td>
                                            <td><Moment format="DD/MM/YYYY h:mm:ss a" date={validation.created_at} /></td>
                                            <td>{validation.status}</td>
                                            <td>
                                                <Link to={`${match.path}/${validation.id}`}>
                                                    <ChevronRight />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            )}

        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminUploadValidation);
